export default {
  DEF_MATERIAL_ITEM: {
    id: '',
    materialName: '',
    materialSize: '',
    type: '',
    pictureUrl: '',
    videoUrl: '',
    meterialGroupId: 0,
    meterialGroup: '',
    createTime: 0,
    modifyTime: 0,
    height: '',
    width: '',
  },
  DEF_MATERIAL_GROUP_ITEM: {
    id: '',
    groupName: '',
    type: '',
  },
  MATERIAL_TYPE: {
    img: 0,
    video: 1,
  },
  // 0审核成功 1审核中 2审核失败
  YOU_KU_STATUS: {
    success: 0,
    doing: 1,
    fail: 2,
  },
};
